module.exports = __webpack_public_path__ + "static/img/纯血鸿蒙.ca927046.png";